import { render } from "./BranchEditModal.vue?vue&type=template&id=6cd767f6&scoped=true"
import script from "./BranchEditModal.vue?vue&type=script&lang=js"
export * from "./BranchEditModal.vue?vue&type=script&lang=js"

import "./BranchEditModal.vue?vue&type=style&index=0&id=6cd767f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd767f6"]])

export default __exports__